export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1200,
  large: 1440
}

export const EMITTER_PROPS = {
  cart: {
    add: 'cart.add',
    update: 'cart.update',
    clear: 'cart.clear',
    change: 'cart.change',
    render: 'cart.render'
  },
  product: {
    updateVariant: 'product.update_variant',
    openModalGallery: 'product.open_modal_gallery',
    changeMedia: 'product.change_media',
    compare: 'product.compare',
    notify: 'product.notify'
  },
  notice: {
    global: 'notice.global'
  },
  quote: {
    create: 'quote.create'
  },
  menu: {
    close: 'menu.close'
  }
}

export const RECENTLY_CONFIG = {
  cookieName: 'gamma_recently_viewed', // Please change prefix every new project 'gamma_' to project name
  cookieSkusName: 'gamma_recently_viewed_skus', // Please change prefix every new project 'gamma_' to project name
  expireTime: 60 * 60 * 24 * 7, // set cookie expire time to 7 days
  maxLimit: 10
}

export const COMPARE_PRODUCT_CONFIG = {
  cookieName: 'gamma_compare_product',
  expireTime: 60 * 60 * 24 * 7, // set cookie expire time to 7 days
  maxLimit: 5
}
